import React from "react";

function ViewIcon({ fill = "#424242" }) {
  return (
    <svg
      width="15"
      height="11"
      viewBox="0 0 15 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5293 4.53C13.732 4.814 13.8333 4.95667 13.8333 5.16667C13.8333 5.37733 13.732 5.51933 13.5293 5.80333C12.6187 7.08067 10.2927 9.83333 7.16667 9.83333C4.04 9.83333 1.71467 7.08 0.804 5.80333C0.601333 5.51933 0.5 5.37667 0.5 5.16667C0.5 4.956 0.601333 4.814 0.804 4.53C1.71467 3.25267 4.04067 0.5 7.16667 0.5C10.2933 0.5 12.6187 3.25333 13.5293 4.53Z"
        stroke={fill}
      />
      <path
        d="M9.1665 5.16797C9.1665 4.63754 8.95579 4.12883 8.58072 3.75375C8.20565 3.37868 7.69694 3.16797 7.1665 3.16797C6.63607 3.16797 6.12736 3.37868 5.75229 3.75375C5.37722 4.12883 5.1665 4.63754 5.1665 5.16797C5.1665 5.6984 5.37722 6.20711 5.75229 6.58218C6.12736 6.95726 6.63607 7.16797 7.1665 7.16797C7.69694 7.16797 8.20565 6.95726 8.58072 6.58218C8.95579 6.20711 9.1665 5.6984 9.1665 5.16797Z"
        stroke={fill}
      />
    </svg>
  );
}

export default ViewIcon;
